import React from "react";

import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

import GlobalNavLink from "./nav-link";
import { ResourcesSubnav } from "./resources-subnav";
import { TeamsSubnav } from "./teams-subnav";
import { WhyAtlassianSubnav } from "./why-atlassian-subnav";

export type DropdownStateProps = {
    readonly currentOpenDropDown: string;
    readonly setCurrentOpenDropDown: React.Dispatch<
        React.SetStateAction<string>
    >;
};

export type GlobalNavLinkContentProps = {
    readonly globalLinksKey: string;
    readonly linkText: string;
    readonly hasSubnav: boolean;
    readonly href?: string;
    readonly productKey?: string;
    readonly content?: JSX.Element | string;
};

const TestContent = (props: { stuff: string }) => (
    <div>HEllO THERE {props.stuff}</div>
);

const GlobalNavLinksContainer = () => {
    const intl = useIntl();
    const [currentOpenDropDown, setCurrentOpenDropDown] = React.useState("");

    const globalLinksProps: GlobalNavLinkContentProps[] = [
        {
            globalLinksKey: "products",
            linkText: intl.formatMessage({
                id: "globalNavigation.Navlink.products",
                defaultMessage: "Products"
            }),
            hasSubnav: true,
            content: <TestContent stuff="products" />
        },
        {
            globalLinksKey: "teams",
            linkText: intl.formatMessage({
                id: "globalNavigation.Navlink.teams",
                defaultMessage: "Teams"
            }),
            hasSubnav: true,
            content: <TeamsSubnav />
        },
        {
            globalLinksKey: "why-atlassian",
            linkText: intl.formatMessage({
                id: "globalNavigation.Navlink.whyAtlassian",
                defaultMessage: "Why Atlassian?"
            }),
            hasSubnav: true,
            content: <WhyAtlassianSubnav />
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "globalNavigation.Navlink.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            content: <ResourcesSubnav />
        },
        {
            globalLinksKey: "enterprise",
            linkText: intl.formatMessage({
                id: "globalNavigation.Navlink.enterprise",
                defaultMessage: "Enterprise"
            }),
            hasSubnav: false,
            href: useLocalizedHref("/enterprise")
        }
    ];

    return (
        <>
            {globalLinksProps.map((globalLink: GlobalNavLinkContentProps) => {
                return (
                    <li className="nav-link" key={globalLink.globalLinksKey}>
                        <GlobalNavLink
                            currentOpenDropDown={currentOpenDropDown}
                            setCurrentOpenDropDown={setCurrentOpenDropDown}
                            {...globalLink}
                        />
                    </li>
                );
            })}
        </>
    );
};

export default GlobalNavLinksContainer;
